import { useState } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import TranslateTemplateNavItem from './TranslateTemplateNavItem';
import TranslateTemplateNavbarSection from './TranslateTemplateNavbarSection';
import TranslateTemplateFooterSection from './TranslateTemplateFooterSection';
import TranslateTemplateHeaderSection from './TranslateTemplateHeaderSection';
import TranslateTemplateSupportFormSection from './TranslateTemplateSupportFormSection';
import LanguageSelect from '../../LanguageSelect';
import { selectPrimaryLanguage } from '../../../knowledge-base/selectors/knowledgeBaseDetails';
import { useAppSelector } from '../../../utils/hooks';
import { View } from 'foundations-components/transitional/components/View';
import { Text } from 'foundations-components/components/Text';
import { SideNav } from 'foundations-components/transitional/components/SideNav';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export default function TranslateTemplateSideNav(props) {
  const [selectedSection, setSelectedSection] = useState(null);
  const masterLanguage = useAppSelector(selectPrimaryLanguage);
  const masterLanguageTranslations = props.values.get(masterLanguage);
  const hasMasterLanguageSupportFormId = !!masterLanguageTranslations.supportFormId;
  const onBackClick = () => setSelectedSection(null);
  return /*#__PURE__*/_jsxs(View, {
    overflowY: "auto",
    blockSize: "100%",
    inlineSize: "410px",
    paddingBlockStart: "200",
    borderInlineEndWidth: "100",
    borderInlineEndStyle: "solid",
    borderInlineEndColor: "border-core-default",
    children: [selectedSection === null && /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsxs(View, {
        paddingBlock: "900",
        paddingInline: "400",
        as: "div",
        children: [/*#__PURE__*/_jsx(Text, {
          as: "h4",
          marginBlockEnd: "0",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "knowledgeContentUI.templateEditor.translateModal.header"
          })
        }), /*#__PURE__*/_jsxs(Text, {
          typography: "body-200",
          marginBlockStart: "200",
          children: [/*#__PURE__*/_jsx(FormattedMessage, {
            message: "knowledgeContentUI.templateEditor.translateModal.previewLanguageSelectPrefix"
          }), /*#__PURE__*/_jsx(LanguageSelect
          // @ts-expect-error ts-migrate(2322) FIXME: Type '{ buttonUse: string; value: any; onChange: (... Remove this comment to see the full error message
          , {
            buttonUse: "transparent",
            value: props.previewLanguage,
            onChange: e => props.onPreviewLanguageChange(e.target.value),
            validLanguages: props.languages
          })]
        })]
      }), /*#__PURE__*/_jsxs(SideNav, {
        children: [/*#__PURE__*/_jsx(TranslateTemplateNavItem
        // @ts-expect-error ts-migrate(2345) FIXME: Argument of type '"NAV"' is not assignable to para... Remove this comment to see the full error message
        , {
          onClick: () => setSelectedSection('NAV'),
          title: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "knowledgeContentUI.templateEditor.translateModal.sections.nav.header"
          })
        }), /*#__PURE__*/_jsx(TranslateTemplateNavItem
        // @ts-expect-error ts-migrate(2345) FIXME: Argument of type '"HEADER"' is not assignable to p... Remove this comment to see the full error message
        , {
          onClick: () => setSelectedSection('HEADER'),
          title: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "knowledgeContentUI.templateEditor.translateModal.sections.header.header"
          })
        }), /*#__PURE__*/_jsx(TranslateTemplateNavItem
        // @ts-expect-error ts-migrate(2345) FIXME: Argument of type '"FOOTER"' is not assignable to p... Remove this comment to see the full error message
        , {
          onClick: () => setSelectedSection('FOOTER'),
          title: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "knowledgeContentUI.templateEditor.translateModal.sections.footer.header"
          })
        }), hasMasterLanguageSupportFormId && /*#__PURE__*/_jsx(TranslateTemplateNavItem
        // @ts-expect-error ts-migrate(2345) FIXME: Argument of type '"SUPPORT_FORM"' is not assignabl... Remove this comment to see the full error message
        , {
          onClick: () => setSelectedSection('SUPPORT_FORM'),
          title: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "knowledgeContentUI.templateEditor.translateModal.sections.supportForm.header"
          })
        })]
      })]
    }), selectedSection === 'NAV' && /*#__PURE__*/_jsx(TranslateTemplateNavbarSection, {
      onBackClick: onBackClick,
      values: props.values,
      languages: props.languages,
      onFieldChange: props.onFieldChange
    }), selectedSection === 'HEADER' && /*#__PURE__*/_jsx(TranslateTemplateHeaderSection, {
      onBackClick: onBackClick,
      values: props.values,
      languages: props.languages,
      onFieldChange: props.onFieldChange
    }), selectedSection === 'FOOTER' && /*#__PURE__*/_jsx(TranslateTemplateFooterSection, {
      onBackClick: onBackClick,
      values: props.values,
      languages: props.languages,
      onFieldChange: props.onFieldChange,
      onSocialLinksFieldChange: props.onSocialLinksFieldChange,
      onFooterLinkFieldChange: props.onFooterLinkFieldChange
    }), selectedSection === 'SUPPORT_FORM' && /*#__PURE__*/_jsx(TranslateTemplateSupportFormSection, {
      onBackClick: onBackClick,
      values: props.values,
      languages: props.languages,
      onFieldChange: props.onFieldChange
    })]
  });
}